import { useContext } from 'react';
import { ProviderRole } from '@bariendo/lib/constants';
import { ProviderDirectoryContext } from '@/contexts/contexts';
import { EMPTY_PROVIDER_DIRECTORY, lookupProviderRole, ProviderSubject } from '@/services/provider-directory';

/**
 * The role a teammate holds, for whatever the caller knows them by — a
 * Practitioner reference or resource, or a display name. Undefined for
 * strangers, patients, and anywhere rendered outside ProviderDirectoryProvider
 * (tests, storybook-style previews), so an avatar never has to guard for it.
 */
export function useProviderRole(subject: ProviderSubject): ProviderRole | undefined {
  const context = useContext(ProviderDirectoryContext);
  return lookupProviderRole(context?.directory ?? EMPTY_PROVIDER_DIRECTORY, subject);
}
